<div class="grid grid-nogutter mb-3">
  <div class="col-12 md:col-6 sm:col-12 sm:mb-2">
    <h6 class="m-0">{{ title | sentenceCase }}</h6>
  </div>
</div>
<div class="projects-data">
  <div class="grid grid-nogutter">
    <div class="col-12 p-0">
      <p-table
        styleClass="p-datatable-sm p-datatable-sm--normal"
        [value]="dynamicCriteria"
        [paginator]="true"
        [rows]="10"
        [tableStyle]="{ 'min-width': '50rem' }"
        [showCurrentPageReport]="true"
        currentPageReportTemplate="Showing {first} - {last} of {totalRecords}"
        autoLayout="true"
        [scrollable]="true"
      >
        <ng-template pTemplate="header">
          <tr>
            <th>S.No</th>
            <th>
              {{'Name' | sentenceCase}}
            </th>
            <th>
              Status
            </th>
            @if(isEditingEnabled){
              @if (helperService.checkResponsive()) {
                <th style="width: 15%;" alignFrozen="right" pFrozenColumn>
                  <ng-container *ngTemplateOutlet="frozenHeader"></ng-container>
                </th>
                } @else {
                <th style="width: 8%;">
                  <ng-container *ngTemplateOutlet="frozenHeader"></ng-container>
                </th>
              }
              <ng-template #frozenHeader>
              Actions
              </ng-template>
            }
          </tr>
        </ng-template>
        <ng-template pTemplate="body" let-criteria let-rowIndex="rowIndex">
          <tr>
            <td>{{ rowIndex + 1 }}</td>
            <td>{{ criteria.name }}</td>
            <td>
              @if(!criteria.isArchived){
                <p-tag value="Active" [rounded]="true" class="pillActive"/>
              }
              @else {
                <p-tag value="Inactive" [rounded]="true" class="pillInactive"  />
              }
            </td>
            @if(isEditingEnabled){
              @if (helperService.checkResponsive()) {
                <td alignFrozen="right" pFrozenColumn>
                  <ng-container *ngTemplateOutlet="frozenData"></ng-container>
                </td>
                } @else {
                <td>
                  <ng-container *ngTemplateOutlet="frozenData"></ng-container>
                </td>
                } 
               <ng-template #frozenData>
                <div class="flex align-items-center gap-2">
                  <p-button
                    pTooltip="Edit" 
                    tooltipPosition="top"
                    [rounded]="true"
                    [text]="true"
                    icon="true"
                    (click)="goToEdit($event, criteria)"
                  >
                    <span class="{{helperService.getEnvironmentName()}}-icon icon-edit-outlined"></span>
                  </p-button>
                  @if(criteria?.firm) {
                    <p-button
                    [pTooltip]="criteria.isArchived? 'Activate': 'Deactivate'"
                    tooltipPosition="top"
                    (click)="onArchive($event, criteria)"
                    [rounded]="true"
                    [text]="true"
                    icon="true"
                    >
                    <span class="{{helperService.getEnvironmentName()}}-icon icon-archive-outlined"></span>
                  </p-button>
                  <p-button
                    pTooltip="Delete" 
                    tooltipPosition="top"
                    [rounded]="true"
                    [text]="true"
                    icon="true"
                    (click)="onDelete($event, criteria)"
                  >
                    <span class="{{helperService.getEnvironmentName()}}-icon icon-delete-outlined red"></span>
                  </p-button>
                  }
                </div>
               </ng-template>
            }
          </tr>
        </ng-template>
      </p-table>
    </div>
  </div>
</div>
